import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["src", "sizes", "defaultSize", "role", "alt", "loading", "decoding", "fetchpriority", "srcset", "width", "height"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { IMAGE_LOADING, IMAGE_DECODING, IMAGE_FETCHPRIORITY } from "../../../constants/image";
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { getPictureSources } from "./utils/get-picture-sources";
import { sizes as defaultSizes } from "./constants";
import { PictureContainer, Image } from "./picture.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Picture = function Picture(_ref) {
  var src = _ref.src,
    sizes = _ref.sizes,
    defaultSize = _ref.defaultSize,
    role = _ref.role,
    alt = _ref.alt,
    loading = _ref.loading,
    decoding = _ref.decoding,
    fetchpriority = _ref.fetchpriority,
    srcset = _ref.srcset,
    width = _ref.width,
    height = _ref.height,
    additionalImageProps = _objectWithoutProperties(_ref, _excluded);
  var sources = srcset ? {
    srcSetWebP: srcset.srcSetWebP,
    srcSet: srcset.srcSet,
    fallback: srcset.original
  } : getPictureSources({
    src: src,
    sizes: sizes,
    defaultSize: defaultSize
  });
  if (!sources) {
    return null;
  }
  var pictureProps = _objectSpread(_objectSpread({}, width && {
    width: width
  }), height && {
    height: height
  });
  return /*#__PURE__*/_jsx("div", {
    style: {
      maxWidth: width
    },
    children: /*#__PURE__*/_jsxs(PictureContainer, _objectSpread(_objectSpread({}, pictureProps), {}, {
      children: [/*#__PURE__*/_jsx("source", {
        srcSet: sources.srcSetWebP,
        type: "image/webp"
      }), /*#__PURE__*/_jsx("source", {
        "data-testid": "default-source",
        srcSet: sources.srcSet
      }), /*#__PURE__*/_jsx(Image, _objectSpread({
        alt: alt,
        height: height,
        loading: loading,
        decoding: decoding,
        fetchpriority: fetchpriority,
        role: role,
        src: sources.fallback,
        width: width
      }, additionalImageProps))]
    }))
  });
};
Picture.propTypes = {
  alt: PropTypes.string.isRequired,
  loading: PropTypes.oneOf(Object.values(IMAGE_LOADING)),
  decoding: PropTypes.oneOf(Object.values(IMAGE_DECODING)),
  fetchpriority: PropTypes.oneOf(Object.values(IMAGE_FETCHPRIORITY)),
  role: PropTypes.string,
  src: PropTypes.string.isRequired,
  sizes: PropTypes.arrayOf(PropTypes.string),
  defaultSize: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  srcset: PropTypes.shape({
    srcSetWebP: PropTypes.string.isRequired,
    srcSet: PropTypes.string.isRequired,
    original: PropTypes.string.isRequired
  })
};
Picture.defaultProps = {
  loading: IMAGE_LOADING.lazy,
  decoding: IMAGE_DECODING.async,
  fetchpriority: IMAGE_FETCHPRIORITY.low,
  role: 'presentation',
  sizes: defaultSizes,
  defaultSize: defaultSizes[defaultSizes.length - 1],
  srcset: null,
  width: undefined,
  height: undefined
};
export default /*#__PURE__*/memo(Picture);